export default __webpack_public_path__ + "static/media/ICIMOD Master logo_Transparent-White.1cda5f19.png";